export default "__VITE_ASSET__plHP4cY4__"